import nexo from "@tiendanube/nexo";

const instance = nexo.create({
  clientId: "9667",
  log: true,
});

export default instance;
